import React, { CSSProperties } from 'react';
import './Title.css';
export const Title = ({ title, style, className }: { title: string; style?: CSSProperties; className?: string }) => (
  <div className={`title_title ${className ?? ''}`} style={style}>
    {title}
  </div>
);
